module.exports = __webpack_public_path__ + "img/logos-HTML-CSS-JS.b2935bec.png";